import Image from 'next/legacy/image'
import { Button, Inline, Stack } from '@machobear/design-system'

import { useLogin } from './context'
import { LoginStepProps } from './types'
import socialLoginImage from './images/enable-social-login.png'

type ExistingSocialUserProps = Pick<LoginStepProps, 'setCurrentStep' | 't'>

const ExistingSocialUser: React.FC<ExistingSocialUserProps> = ({
  setCurrentStep,
  t
}) => {
  const { setExistingSocialState, setSocial } = useLogin()

  const handleSignInByEmail = () => {
    setExistingSocialState(false)
    setSocial({})
    setCurrentStep('login')
  }

  return (
    <Stack space="medium" align="center">
      <Image src={socialLoginImage} alt="social login settings" />
      <Button
        id="web-existing-social-user-submit-button"
        onClick={handleSignInByEmail}
      >
        {t('b.auth.view.existing.user.button', 'Sign In by Email')}
      </Button>
      <Inline space="none" align="center">
        <Button
          variant="transparent"
          type="button"
          onClick={handleSignInByEmail}
        >
          {t('common.back', 'Back')}
        </Button>
      </Inline>
    </Stack>
  )
}

export default ExistingSocialUser
